import { isTrustedParentOrigin, parentTargetOrigin } from '@/constants/game/products'

const allowedParents = String(process.env.VUE_APP_ALLOWED_PARENT_ORIGINS || '')
    .split(',')
    .map((origin) => origin.trim())
    .filter(Boolean)

let rememberedOrigin = ''

export function acceptParentOrigin(origin: string): boolean {
    const selfOrigin = window.location.origin
    if (!isTrustedParentOrigin(origin, allowedParents, selfOrigin)) return false
    rememberedOrigin = origin
    return true
}

export function postToParent(message: unknown): void {
    if (!window.parent || window.parent === window) return
    window.parent.postMessage(message, parentTargetOrigin(rememberedOrigin, allowedParents, window.location.origin))
}
